export enum TranslationKeys {
  Header = 'jbp-manager-dialog-header',
  NoData = 'jbp-commitment-no-data',
  InfoIconContent = 'jbp-commitment-manager-dialog-info-icon-content',
  Email = 'jbp-commitment-manager-email',
  FirstName = 'jbp-commitment-manager-first-name',
  LastName = 'jbp-commitment-manager-last-name',
  CommentDialogTitle = 'jbp-commitment-manager-comment-dialog-title',
  CommentDialogDescription = 'jbp-commitment-manager-comment-dialog-description',
}
